import React from 'react';
import { UI_CONSTANTS } from '../constants';

interface StatusBadgeProps {
  status: 'loading' | 'error' | 'eserv-only' | 'qbo-only' | 'both' | 'ready' | 'success' | 'idle';
  text: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, text }) => {
  const getColorClass = () => {
    switch (status) {
      case 'loading': return 'bg-yellow-100 text-yellow-800';
      case 'error': return 'bg-red-100 text-red-800';
      case 'both': return 'bg-green-100 text-green-800';
      case 'success': return 'bg-green-100 text-green-800';
      case 'eserv-only': return 'bg-orange-100 text-orange-800';
      case 'qbo-only': return 'bg-blue-100 text-blue-800';
      case 'ready': return 'bg-gray-100 text-gray-800';
      case 'idle': return 'bg-gray-100 text-gray-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getIcon = () => {
    switch (status) {
      case 'loading': return '⏳';
      case 'error': return '❌';
      case 'both': return '✅';
      case 'success': return '✅';
      case 'eserv-only': return '⚠️';
      case 'qbo-only': return 'ℹ️';
      case 'ready': return '⏸️';
      case 'idle': return '⏸️';
      default: return '⏸️';
    }
  };

  return (
    <span className={`inline-flex items-center px-1 py-0.5 rounded text-xs font-medium ${getColorClass()}`}>
      {getIcon()} {text}
    </span>
  );
};

export default StatusBadge;
